export type SyncRecordBase = {
  _id: string; // the DB recordId - same ID as used for the API
  _rev?: string; // @deprecated - remove once PouchDB migration is complete
  userId: string;
  scanId: string;
  isSynced: boolean;
  isSyncing: boolean;
  isFailed: boolean;
  errorMessage?: string;
  createdAt?: number;
  updatedAt?: number;
  retryCount?: number;
  firstErrorAt?: number;
};

export interface SyncTypeStatus {
  syncRecords: number;
  pending: number;
  synced: number;
  failed: number;
  syncing: number;
  progress: number;
  isComplete: boolean;
}

export const getBlankSyncTypeStatus = (): SyncTypeStatus => ({
  syncRecords: 0,
  pending: 0,
  synced: 0,
  failed: 0,
  syncing: 0,
  progress: 0,
  isComplete: false,
});

export const getSyncTypeStatus = (items: SyncRecordBase[], synced: number): SyncTypeStatus => {
  const itemCountIgnoringSynced = items.filter(item => !item.isSynced).length;
  const syncRecords = itemCountIgnoringSynced + synced;
  const pending = items.filter(item => !item.isFailed).length;
  const failed = items.filter(item => item.isFailed).length;
  const syncing = items.filter(item => item.isSyncing).length;

  return {
    syncRecords,
    pending,
    synced,
    failed,
    syncing,
    progress: syncRecords > 0 ? (synced + failed) / syncRecords : 1,
    isComplete: synced + failed === syncRecords,
  };
};

export const mergeSyncTypeStatus = (statuses: SyncTypeStatus[]): SyncTypeStatus => {
  const syncRecords = statuses.reduce((acc, status) => acc + status.syncRecords, 0);
  const synced = statuses.reduce((acc, status) => acc + status.synced, 0);
  const failed = statuses.reduce((acc, status) => acc + status.failed, 0);
  const syncing = statuses.reduce((acc, status) => acc + status.syncing, 0);
  const pending = statuses.reduce((acc, status) => acc + status.pending, 0);
  return {
    syncRecords,
    pending,
    synced,
    failed,
    syncing,
    progress: syncRecords > 0 ? (synced + failed) / syncRecords : 1,
    isComplete: synced + failed === syncRecords,
  };
};
